module.exports = __webpack_public_path__ + "static/media/logo.79f761f3.png";